import React, { useRef, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, InputGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import login1 from "../../../assets/images/login/1.jpg";
import login2 from "../../../assets/images/login/2.jpg";
import login3 from "../../../assets/images/login/3.jpg";
import axios from "axios";
import { base_url } from "../../../components/apiCall/webserviceurl";
import { toast,ToastContainer } from "react-toastify";
import Footer from "../../../components/partials/dashboard/FooterStyle/footer";

// img
import logo from "../../../assets/images/logo/logo.png";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const Recoverpw = () => {
console.log(".....................................");
    const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
const [email,setEmail]=useState("")
const [OTP,setOTP]=useState("")
  const [isLoading, setIsLoading] = useState(false);

  const [showEmailScreen,setShowEmailScreen]=useState(true)
  const [showOTP,setShowOTP]=useState(false)
  const [showPassWordScreen,setShowPassWordScreen]=useState(false)
  const [message, setMessage] = useState("");
  const [reset, setReset] = useState("");
  const [confirmPassword, setConfirmPassword] = useState('');
  const [password, setPassword] = useState('');
 
  const navigate = useNavigate()
    const inputRefs = useRef([]);

    // ################### SEND OTP  ######################### 
    const sendOTP = async () => {
      setIsLoading(true);
      try {
        const forgotPasswordJson = {
          email: email
        }
      
        const resp = await axios.post(`${base_url}/auth/send-otp`,forgotPasswordJson)
        console.log(resp.data);
        if(resp.data?.success){
          toast.success(resp?.data?.message)
          setShowEmailScreen(false)
          setShowOTP(true)
          setShowPassWordScreen(false)
          // setShowOTP(false)
          // setShowPassWordScreen(true)
        }
        else{
          toast.error(resp?.data?.message)
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
    
          // You can also show a toast notification:
          toast.error(error.response.data.message);
        } else {
          toast.error(error.message || "Something went wrong");
        }
      }finally {
      setIsLoading(false); // Hide loading GIF after done
    }
      
    }
    const handleChange = (index: number, value: string) => {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;
      setOtpValues(newOtpValues);
      if (value !== '' && index < otpValues.length - 1) {
          inputRefs.current[index + 1]?.focus();
      }
  };
  
      // ################### VERIFY OTP  ######################### 

  console.log(otpValues.join(''));
  const verifyOTP =async (e) => {
    e.preventDefault();
    try {
      if (otpValues.every(value => value !== '')) {
          const enteredOtp = otpValues.join('');
          setOTP(enteredOtp)
          const forgotPasswordJson = {
            email: email,
            otp:enteredOtp
          }
          
          const resp = await axios.post(`${base_url}/auth/verify-otp`,forgotPasswordJson)
          console.log(resp.data);
          if(resp.data?.success){
            toast.success(resp?.data?.message)
            setShowPassWordScreen(true)
            setShowOTP(false)
            setShowEmailScreen(false)
          }  else{
            toast.error(resp?.data?.message)
          }
  
      } else {
          toast.warning('Please fill all OTP fields');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
  
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message || "Something went wrong");
      }
    }
  }

  const reset_password = async () => {
    if(password !==confirmPassword){
      toast.error("New password and Confirm Password is not matching")

    }
   try {
     const forgotPasswordJson = {
       email: email,
       otp:OTP,
       newPassword:password,
       confirmPassword:confirmPassword,
     }

     const resp = await axios.post(`${base_url}/auth/reset-password`,forgotPasswordJson)
     console.log("message from reset", resp.data);
     if(resp.data?.success){
       toast.success(resp?.data?.message)
      setTimeout(() => {
      navigate(`${process.env.PUBLIC_URL}/auth/sign-in`);
    }, 3000);
     }  else{
       toast.error(resp?.data?.message)
     }
   } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {

      // You can also show a toast notification:
      toast.error(error.response.data.message);
    } else {
      toast.error(error.message || "Something went wrong");
    }
  }
  }
  return (
    <>
      <section className="sign-in-page" id="login-in-page">
        <Container fluid>
          <Row className="align-items-center">
            <Col md={6} className="overflow-hidden position-relative">
              <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
              <div className="container-inside z-1">
                <div className="main-circle circle-small"></div>
                <div className="main-circle circle-medium"></div>
                <div className="main-circle circle-large"></div>
                <div className="main-circle circle-xlarge"></div>
                <div className="main-circle circle-xxlarge"></div>
              </div>
              <div className="sign-in-detail container-inside-top">
                <Swiper
                  className="list-inline m-0 p-0"
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{ delay: 2000, disableOnInteraction: false }}
                >
                  <SwiperSlide>
                    <img
                      src={login1}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      RESEARCH & DEVELOPMENT
                    </h2>
                    <p className="font-size-16 text-white mb-0 d-none d-md-block">
                      Pioneering robotics research shaping healthcare and
                      industry.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login2}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      EDUCATION RESEARCH & TRAINING
                    </h2>
                    <p className="font-size-16 text-white mb-0 d-none d-md-block">
                      Empowering learners and educators through emerging tech
                      education.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login3}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      STARTUP & ENTREPRENEURSHIP
                    </h2>
                    <p className="font-size-16 text-white mb-0 d-none d-md-block">
                      Incubating 21st-century startups with IIT-Delhi
                      innovation.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login3}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      INTERNATIONAL COLLABORATION
                    </h2>
                    <p className="font-size-16 text-white mb-0 d-none d-md-block">
                      Global partnerships driving innovation and
                      interdisciplinary growth.
                    </p>
                  </SwiperSlide>
                </Swiper>
                {/* <Swiper
                  className="list-inline m-0 p-0"
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{ delay: 2000, disableOnInteraction: false }}
                >
                  <SwiperSlide>
                    <img
                      src={login1}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Admin Panel for Course Management
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      We provide a comprehensive platform for managing and
                      delivering courses to students.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login2}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Manage Courses Efficiently
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      The admin panel allows you to easily manage course content
                      and student access.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login3}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Empower Students with Knowledge
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      Provide a seamless learning experience with a
                      user-friendly admin panel.
                    </p>
                  </SwiperSlide>
                </Swiper> */}
              </div>
            </Col>
            
            <Col md="6" className="p-0">
            <ToastContainer/>
      <div className="container-fluid bg-white d-flex flex-column justify-content-center align-items-center py-4 w-full mt-4">

                {/* <div className="w-100" style={{ maxWidth: '500px' }}> */}

                      <div className="d-inline-flex align-items-center justify-content-center gap-2 sign_logoContainer">
                      <img src={logo} alt="Logo" className="w-100 h-100" />
                    </div>
                <div className="login-card login-dark p-4 rounded bg-white" style={{width:"100%"}}>
                  <div>

       
                    {/* ####################### SEND MAIL####################################  */}
                    {showEmailScreen && <div className=" d-flex flex-column justify-center align-center login-main  reset_password" style={{ display: "block" }} >
                  <p className="font-size-16">
                  Enter your email address and we'll send you an email with
                  instructions to reset your password.
                </p>

                      <Form className="theme-form" >
                        <h4 className="my-3" >Reset Your Password</h4>
                        <FormGroup>
                          {/* <label className="col-form-label">Email</label> */}
                          <Row>
                            <Col xs="12" sm="12">
                              <Form.Group className="form-group text-start">
                                <InputGroup>
                                  <Form.Control
                                    className="form-control mb-0"
                                    type="text" placeholder='Enter Your Email' value={email ?? ""} onChange={(e) => {
                                      setEmail(e.target.value)

                                    }}
                                  />

                                </InputGroup>
                              </Form.Group>
                            </Col>
                            <Col xs="12">
                              <div className="text-left">
                                <Button
                                  block
                                  color="primary"
                                  className="m-t-10 px-4 mt-2"
                                  onClick={sendOTP}
                                  disabled={isLoading}
                                >
                                  {isLoading && (
                                    <img
                                      src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif"
                                      alt="Loading..."
                                      style={{ width: 24, height: 24, marginRight: 8 }}
                                    />
                                  )}
                                  {isLoading ? 'Sending OTP...' : 'Send OTP'}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </FormGroup>
                      </Form>
                    </div>
                    }

                    {/* ##########################################VERIFY OTP#################################################  */}
           {showOTP && (
  <div className="d-flex flex-column justify-center align-center login-main reset_password" style={{ display: "block" }}>
   
    <p className="font-size-16 mt-2">
      Please enter the OTP (One-Time Password) sent to your registered email to complete your verification.
    </p>
    

<Form className="theme-form text-center">
  <h4 className="my-3">Enter OTP</h4>

  <FormGroup className="d-flex flex-column align-items-center">
    <div className="otp-input-container d-flex justify-content-center flex-wrap mb-3" style={{ width: '318px' }}>
      {otpValues.map((value, index) => (
        <input
          key={index}
          ref={(ref) => inputRefs.current[index] = ref}
          type="text"
          value={value}
          maxLength={1}
          onChange={(e) => handleChange(index, e.target.value)}
          className="form-control text-center mx-1"
          style={{
            width: '45px',
            height: '45px',
            fontSize: '18px',
            borderRadius: '5px',
            border: value ? '1px solid green' : '1px solid #ff00008f',
          }}
        />
      ))}
    </div>

    <Button
      type="submit"
      className="Button Button-primary mt-2"
      style={{ width: '318px' }}
      onClick={verifyOTP}
    >
      Submit
    </Button>
  </FormGroup>
</Form>

  </div>
)}

                    {/* /////////////////////Confirm --Password Screen /////////////////////////////////////*/}
 {showPassWordScreen && (
  <div className="d-flex flex-column justify-center align-center login-main reset_password" style={{ display: "block" }}>
    <Form className="theme-form my-2" style={{ width: "100%" }}>
      <h4 className="my-3 text-center">Reset Your Password</h4>

      <FormGroup className="mb-3">
        <Row>
          <Col xs="12">
            <Form.Group className="form-group text-start">
              <InputGroup>
                <Form.Control
                  className="form-control"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="New Password"
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
      </FormGroup>

      <FormGroup className="mb-3">
        <Row>
          <Col xs="12">
            <Form.Group className="form-group text-start">
              <InputGroup>
                <Form.Control
                  className="form-control"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm Password"
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
      </FormGroup>

      <Row>
        <Col xs="12">
          <div className="text-left">
            <Button
              color="primary"
              className="mt-2 px-4 w-100"
              onClick={reset_password}
            >
              Reset Password
            </Button>
          </div>
        </Col>
      </Row>

      {reset && (
        <div className="text-center">
          <label className="col-form-label mt-3">{reset}</label>
        </div>
      )}
    </Form>
  </div>
)}



                    <div className="mt-2 mt-md-4">
                      <Footer />
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}

            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Recoverpw;




      //     <Col md="6" className="p-0">
      // <div className="container-fluid bg-white d-flex flex-column justify-content-center align-items-center py-4 w-full mt-4">

      //           {/* <div className="w-100" style={{ maxWidth: '500px' }}> */}

      //                 <div className="d-inline-flex align-items-center justify-content-center gap-2 sign_logoContainer">
      //                 <img src={logo} alt="Logo" className="w-100 h-100" />
      //               </div>
      //           <div className="login-card login-dark p-4 rounded bg-white">
      //             <div>

       
      //               {/* ####################### SEND MAIL####################################  */}
      //               {showEmailScreen && <div className=" d-flex flex-column justify-center align-center login-main" style={{ display: "block" }} >
      //             <p className="font-size-16">
      //             Enter your email address and we'll send you an email with
      //             instructions to reset your password.
      //           </p>

      //                 <Form className="theme-form" >
      //                   <h4 className="mt-0" >Reset Your Password</h4>
      //                   <FormGroup>
      //                     {/* <label className="col-form-label">Email</label> */}
      //                     <Row>
      //                       <Col xs="12" sm="12">
      //                         <Form.Group className="form-group text-start">
      //                           <InputGroup>
      //                             <Form.Control
      //                               className="form-control mb-0"
      //                               type="text" placeholder='Enter Your Email' value={email ?? ""} onChange={(e) => {
      //                                 setEmail(e.target.value)

      //                               }}
      //                             />

      //                           </InputGroup>
      //                         </Form.Group>
      //                       </Col>
      //                       <Col xs="12">
      //                         <div className="text-end">
      //                           <Button
      //                             block
      //                             color="primary"
      //                             className="m-t-10"
      //                             onClick={sendOTP}
      //                             disabled={isLoading}
      //                           >
      //                             {isLoading && (
      //                               <img
      //                                 src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif"
      //                                 alt="Loading..."
      //                                 style={{ width: 24, height: 24, marginRight: 8 }}
      //                               />
      //                             )}
      //                             {isLoading ? 'Sending OTP...' : 'Send OTP'}
      //                           </Button>
      //                         </div>
      //                       </Col>
      //                     </Row>
      //                   </FormGroup>
      //                 </Form>
      //               </div>
      //               }

      //               {/* ##########################################VERIFY OTP#################################################  */}
      //               {showOTP && <>  <div className="mt-4 ms-4">
      //                 <span className="reset-password-link">
      //                   {"If don't receive OTP? "}
      //                 </span>
      //               </div>

      //                 <div className='page-body d-flex justify-content-center align-items-center w-100' >
      //                   {<div className='card p-2' style={{ maxWidth: '600px', width: '100%', display: 'flex', flexDirection: 'column', }}>
      //                     <div className='text-center'>
      //                       <h2 className='my-2'>Enter OTP</h2>
      //                     </div>
      //                     <form onSubmit={verifyOTP} className="otp-form text-center">
      //                       <div className="otp-input-container">
      //                         {otpValues.map((value, index) => (
      //                           <input
      //                             ref={(ref) => inputRefs.current[index] = ref}
      //                             key={index}
      //                             type="text"
      //                             value={value}
      //                             maxLength={1}
      //                             onChange={(e) => handleChange(index, e.target.value)}
      //                             style={{
      //                               width: '35px',
      //                               height: '35px',
      //                               margin: '5px',
      //                               textAlign: 'center',
      //                               borderRadius: "5px",
      //                               // border: value ? '1px solid green' : value === "" ? '1px solid black' : '1px solid #ccc',
      //                               border: value ? '1px solid green' : '1px solid red'
      //                             }}
      //                           />
      //                         ))}
      //                       </div>
      //                       <Button className='Button Button-primary my-3' type="submit">Submit</Button>
      //                     </form>
      //                   </div>}
      //                 </div></>}

      //               {/* /////////////////////Confirm --Password Screen /////////////////////////////////////*/}
      //               {showPassWordScreen && <div className=" " style={{ width: "300px" }}>
      //                 <Form className="my-2" >
      //                   <h4 className="my-2">Reset Your Password</h4>
      //                   <FormGroup className="">
      //                     <div className="  ">
      //                       <Form.Group className="form-group text-start">
      //                         <InputGroup>
      //                           <Form.Control
      //                             className="form-control mb-0"
      //                             type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='New Password'
      //                           />

      //                         </InputGroup>
      //                       </Form.Group>
      //                       <div className="form-input position-relative">
      //                         <Form.Group className="form-group text-start">
      //                           <InputGroup>
      //                             <Form.Control
      //                               className="form-control mb-0"
      //                               type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder='Confirm Password'
      //                             />

      //                           </InputGroup>
      //                         </Form.Group>
      //                         {/* <div className="show-c show-hide" onClick={() => setShow(!show)}> */}
      //                         <span className="show"> </span>
      //                       </div>
      //                     </div>
      //                     <Col xs="12">
      //                       <div className="text-end">
      //                         <Button color="primary" className="m-t-10" onClick={reset_password}>Reset Password</Button>
      //                       </div>
      //                     </Col>
      //                     <label className="col-form-label mt-2 mb-3">{reset}</label>
      //                     {/* </Row> */}
      //                   </FormGroup>
      //                 </Form>
      //               </div>}


      //               <div className="mt-2 mt-md-4">
      //                 <Footer />
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         {/* </div> */}

      //       </Col>




// import React, { useRef, useState } from "react";
// import { Row, Col, Form, Container, Button, FormGroup, InputGroup } from "react-bootstrap";
// import { Link, useNavigate } from "react-router-dom";

// //swiper
// import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore from "swiper";
// import { Navigation, Autoplay } from "swiper/modules";
// import login1 from "../../../assets/images/login/1.jpg";
// import login2 from "../../../assets/images/login/2.jpg";
// import login3 from "../../../assets/images/login/3.jpg";
// import axios from "axios";
// import { base_url } from "../../../components/apiCall/webserviceurl";
// import { toast } from "react-toastify";


// // install Swiper modules
// SwiperCore.use([Navigation, Autoplay]);

// const Recoverpw = () => {
// console.log(".....................................");
//     const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
// const [email,setEmail]=useState("")
// const [OTP,setOTP]=useState("")
//   const [isLoading, setIsLoading] = useState(false);

//   const [showEmailScreen,setShowEmailScreen]=useState(true)
//   const [showOTP,setShowOTP]=useState(false)
//   const [showPassWordScreen,setShowPassWordScreen]=useState(false)
//   const [message, setMessage] = useState("");
//   const [reset, setReset] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [password, setPassword] = useState('');
 
//   const navigate = useNavigate()
//     const inputRefs = useRef([]);

//     // ################### SEND OTP  ######################### 
//     const sendOTP = async () => {
//       setIsLoading(true);
//       try {
//         const forgotPasswordJson = {
//           email: email
//         }
      
//         const resp = await axios.post(`${base_url}/auth/send-otp`,forgotPasswordJson)
//         console.log(resp.data);
//         if(resp.data?.success){
//           toast.success(resp?.data?.message)
//           setShowEmailScreen(false)
//           setShowOTP(true)
//           setShowPassWordScreen(false)
//         }
//         else{
//           toast.error(resp?.data?.message)
//         }
//       } catch (error) {
//         if (error.response && error.response.data && error.response.data.message) {
    
//           // You can also show a toast notification:
//           toast.error(error.response.data.message);
//         } else {
//           toast.error(error.message || "Something went wrong");
//         }
//       }finally {
//       setIsLoading(false); // Hide loading GIF after done
//     }
      
//     }
//     const handleChange = (index: number, value: string) => {
//       const newOtpValues = [...otpValues];
//       newOtpValues[index] = value;
//       setOtpValues(newOtpValues);
//       if (value !== '' && index < otpValues.length - 1) {
//           inputRefs.current[index + 1]?.focus();
//       }
//   };
  
//       // ################### VERIFY OTP  ######################### 

//   console.log(otpValues.join(''));
//   const verifyOTP =async (e) => {
//     e.preventDefault();
//     try {
//       if (otpValues.every(value => value !== '')) {
//           const enteredOtp = otpValues.join('');
//           setOTP(enteredOtp)
//           const forgotPasswordJson = {
//             email: email,
//             otp:enteredOtp
//           }
          
//           const resp = await axios.post(`${base_url}/auth/verify-otp`,forgotPasswordJson)
//           console.log(resp.data);
//           if(resp.data?.success){
//             toast.success(resp?.data?.message)
//             setShowPassWordScreen(true)
//             setShowOTP(false)
//             setShowEmailScreen(false)
//           }  else{
//             toast.error(resp?.data?.message)
//           }
  
//       } else {
//           toast.warning('Please fill all OTP fields');
//       }
//     } catch (error) {
//       if (error.response && error.response.data && error.response.data.message) {
  
//         toast.error(error.response.data.message);
//       } else {
//         toast.error(error.message || "Something went wrong");
//       }
//     }
//   }

//   const reset_password = async () => {
//     if(password !==confirmPassword){
//       toast.error("New password and Confirm Password is not matching")

//     }
//    try {
//      const forgotPasswordJson = {
//        email: email,
//        otp:OTP,
//        newPassword:password,
//        confirmPassword:confirmPassword,
//      }

//      const resp = await axios.post(`${base_url}/auth/reset-password`,forgotPasswordJson)
//      console.log("message from reset", resp.data);
//      if(resp.data?.success){
//        toast.success(resp?.data?.message)
//       setTimeout(() => {
//       navigate(`${process.env.PUBLIC_URL}/auth/sign-in`);
//     }, 3000);
//      }  else{
//        toast.error(resp?.data?.message)
//      }
//    } catch (error) {
//     if (error.response && error.response.data && error.response.data.message) {

//       // You can also show a toast notification:
//       toast.error(error.response.data.message);
//     } else {
//       toast.error(error.message || "Something went wrong");
//     }
//   }
//   }
//   return (
//     <>
//       <section className="sign-in-page" id="login-in-page">
//         <Container fluid>
//           <Row className="align-items-center">
//             <Col md={6} className="overflow-hidden position-relative">
//               <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
//               <div className="container-inside z-1">
//                 <div className="main-circle circle-small"></div>
//                 <div className="main-circle circle-medium"></div>
//                 <div className="main-circle circle-large"></div>
//                 <div className="main-circle circle-xlarge"></div>
//                 <div className="main-circle circle-xxlarge"></div>
//               </div>
//               <div className="sign-in-detail container-inside-top">
//                 <Swiper
//                   className="list-inline m-0 p-0"
//                   spaceBetween={30}
//                   centeredSlides={true}
//                   loop={true}
//                   autoplay={{ delay: 2000, disableOnInteraction: false }}
//                 >
//                   <SwiperSlide>
//                     <img
//                       src={login1}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       RESEARCH & DEVELOPMENT
//                     </h2>
//                     <p className="font-size-16 text-white mb-0 d-none d-md-block">
//                       Pioneering robotics research shaping healthcare and
//                       industry.
//                     </p>
//                   </SwiperSlide>
//                   <SwiperSlide>
//                     <img
//                       src={login2}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       EDUCATION RESEARCH & TRAINING
//                     </h2>
//                     <p className="font-size-16 text-white mb-0 d-none d-md-block">
//                       Empowering learners and educators through emerging tech
//                       education.
//                     </p>
//                   </SwiperSlide>
//                   <SwiperSlide>
//                     <img
//                       src={login3}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       STARTUP & ENTREPRENEURSHIP
//                     </h2>
//                     <p className="font-size-16 text-white mb-0 d-none d-md-block">
//                       Incubating 21st-century startups with IIT-Delhi
//                       innovation.
//                     </p>
//                   </SwiperSlide>
//                   <SwiperSlide>
//                     <img
//                       src={login3}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       INTERNATIONAL COLLABORATION
//                     </h2>
//                     <p className="font-size-16 text-white mb-0 d-none d-md-block">
//                       Global partnerships driving innovation and
//                       interdisciplinary growth.
//                     </p>
//                   </SwiperSlide>
//                 </Swiper>
//                 {/* <Swiper
//                   className="list-inline m-0 p-0"
//                   spaceBetween={30}
//                   centeredSlides={true}
//                   loop={true}
//                   autoplay={{ delay: 2000, disableOnInteraction: false }}
//                 >
//                   <SwiperSlide>
//                     <img
//                       src={login1}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       Admin Panel for Course Management
//                     </h2>
//                     <p className="font-size-16 text-white mb-0">
//                       We provide a comprehensive platform for managing and
//                       delivering courses to students.
//                     </p>
//                   </SwiperSlide>
//                   <SwiperSlide>
//                     <img
//                       src={login2}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       Manage Courses Efficiently
//                     </h2>
//                     <p className="font-size-16 text-white mb-0">
//                       The admin panel allows you to easily manage course content
//                       and student access.
//                     </p>
//                   </SwiperSlide>
//                   <SwiperSlide>
//                     <img
//                       src={login3}
//                       className="signin-img img-fluid mb-5 rounded-3"
//                       alt="images"
//                     />
//                     <h2 className="mb-3 text-white fw-semibold">
//                       Empower Students with Knowledge
//                     </h2>
//                     <p className="font-size-16 text-white mb-0">
//                       Provide a seamless learning experience with a
//                       user-friendly admin panel.
//                     </p>
//                   </SwiperSlide>
//                 </Swiper> */}
//               </div>
//             </Col>
            
//               <Col md="6" className="p-0">
//               <div className="container-fluid bg-light min-vh-100 d-flex flex-column justify-content-center align-items-center py-4 w-full" >
//   {/* <div className="w-100" style={{ maxWidth: '500px' }}> */}

//             <div className="login-card login-dark shadow p-4 rounded bg-white">
//               <div>



//                 {/* ####################### SEND MAIL####################################  */}
//                {showEmailScreen&& <div className=" d-flex justify-center align-center login-main" style={{ display: "block" }} >
//                   {/* <Form className="theme-form" onSubmit={}> */}
//                   <Form className="theme-form" >
//                     <h4 className="my-4" >Reset Your Password</h4>
//                     <FormGroup>
//                       {/* <label className="col-form-label">Email</label> */}
//                       <Row>
//                         <Col xs="12" sm="12">
//                          <Form.Group className="form-group text-start">
//                   <InputGroup>
//                     <Form.Control
//                       className="form-control mb-0"
//                       type="text" placeholder='Enter Your Email' value={email??""} onChange={(e)=>{
//                               setEmail(e.target.value)

//                           }}
//                     />
                  
//                   </InputGroup>
//                 </Form.Group>
//                           {/* <input className="mb-1" type="text" placeholder='Enter Your Email' value={email??""} onChange={(e)=>{
//                               setEmail(e.target.value)

//                           }} /> */}
//                         </Col>
//                         <Col xs="12">
//                           <div className="text-end">
//       <Button
//         block
//         color="primary"
//         className="m-t-10"
//         onClick={sendOTP}
//         disabled={isLoading}
//       >
//         {isLoading && (
//           <img
//             src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif"
//             alt="Loading..."
//             style={{ width: 24, height: 24, marginRight: 8 }}
//           />
//         )}
//         {isLoading ? 'Sending OTP...' : 'Send OTP'}
//       </Button>
//     </div>
//                         </Col>
//                       </Row>
//                     </FormGroup>
//                     </Form>
//                     </div>
                    
                    
//                     }




// {/* ##########################################VERIFY OTP#################################################  */}


//                   {showOTP&& <>  <div className="mt-4 ms-4">
//                       <span className="reset-password-link">
//                         {"If don't receive OTP? "}
//                         {/* <Link className="Button-link text-danger" to={Href}>{Resend}</Link> */}
//                       </span>
//                     </div>

// <div className='page-body d-flex justify-content-center align-items-center w-100' >
//             { <div className='card p-2' style={{ maxWidth: '600px', width: '100%', display: 'flex', flexDirection: 'column', }}>
//                 <div className='text-center'>
//                     {/* <img className='my-2' src={require('../../assets/download.png')} style={{ width: '100px', height: '70px' }} alt='blueplanet' /> */}
//                     <h2 className='my-2'>Enter OTP</h2>
//                 </div>
//                 <form onSubmit={verifyOTP} className="otp-form text-center">
//                     <div className="otp-input-container">
//                         {otpValues.map((value, index) => (
//                             <input
//                                 ref={(ref) => inputRefs.current[index] = ref}
//                                 key={index}
//                                 type="text"
//                                 value={value}
//                                 maxLength={1}
//                                 onChange={(e) => handleChange(index, e.target.value)}
//                                 style={{
//                                     width: '35px',
//                                     height: '35px',
//                                     margin: '5px',
//                                     textAlign: 'center',
//                                     borderRadius: "5px",
//                                     // border: value ? '1px solid green' : value === "" ? '1px solid black' : '1px solid #ccc',
//                                     border: value ? '1px solid green' : '1px solid red'
//                                 }}
//                             />
//                         ))}
//                     </div>
//                     <Button className='Button Button-primary my-3' type="submit">Submit</Button>
//                 </form>
//             </div>}
//         </div></>}
//                     {/* <div ref={myRef} style={{ display: "block" }} ><FormGroup >
//                       <label className="col-form-label mt-2 mb-3">{message}</label>
//                       <Row>
//                         <Col>
//                           <input className="text-center opt-text" type="text" value={otp1}  onChange={handleotpchange} maxLength={2} />
//                         </Col>
//                         <Col>
//                           <input className="text-center opt-text" type="text" value={otp2} onChange={handleotpchange} maxLength={2} />
//                         </Col>
//                         <Col>
//                           <input className="text-center opt-text" type="text" value={otp3}  onChange={handleotpchange}maxLength={2} />
//                         </Col>
//                       </Row>
//                       <Button color="primary" block className=" w-100 mt-3" onClick={verify_otp_Button}>{VerifyOtp}</Button>
//                     </FormGroup></div> */}
//                     {/* <Link className="forgot-link" to={`${process.env.PUBLIC_URL}/authentication/ForgetPassword/CreatePassword`}  >
//                       {Resend}
//                     </Link> */}

              




//                 {/* /////////////////////Confirm --Password Screen /////////////////////////////////////*/}
//                {showPassWordScreen&& <div className=" " style={{width:"300px"}}>
//                   <Form className="my-2" >
//                     <h4 className="my-2">Reset Your Password</h4>
//                     <FormGroup className="">
//                       {/* <label className="col-form-label">Enter Your Confirm or Current Password</label> */}
//                       {/* <Row> */}
//                       <div className="  ">
//                         {/* <FormGroup> */}
//                         {/* <label className="col-form-label">{EmailAddress}</label> */}
//                         {/* <input className="" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='New Password' /> */}
//                          <Form.Group className="form-group text-start">
//                   <InputGroup>
//                     <Form.Control
//                       className="form-control mb-0"
//                      type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='New Password'
//                     />
                  
//                   </InputGroup>
//                 </Form.Group>
//                         {/* </FormGroup> */}
//                         {/* <FormGroup> */}
//                         {/* <label className="col-form-label">{Password}</label> */}
//                         <div className="form-input position-relative">
//                           {/* <input className="" type="password" value={confirmPassword}  onChange={(e)=>setConfirmPassword(e.target.value)} placeholder='Confirm Password' /> */}
//                               <Form.Group className="form-group text-start">
//                   <InputGroup>
//                     <Form.Control
//                       className="form-control mb-0"
//                      type="password" value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} placeholder='Confirm Password'
//                     />
                  
//                   </InputGroup>
//                 </Form.Group>
//                           {/* <div className="show-c show-hide" onClick={() => setShow(!show)}> */}
//                           <span className="show"> </span>
//                         </div>
//                       </div>
//                       {/* </FormGroup> */}
//                       {/* </div> */}
//                       {/* <div className='login-main blueLogin'><Col xs="12" sm="12">
//                             <input className="mb-1" type="password" value={password} placeholder='Write Password' defaultValue=""/>
//                           </Col>
//                           <Col xs="12" sm="12">
//                             <input className="mb-1" type="password" value={confirmPassword} placeholder='Confirm Password'  />
//                           </Col></div> */}
//                       <Col xs="12">
//                         <div className="text-end">
//                           <Button color="primary" className="m-t-10" onClick={reset_password}>Reset Password</Button>
//                         </div>
//                       </Col>
//                       <label className="col-form-label mt-2 mb-3">{reset}</label>
//                       {/* </Row> */}
//                     </FormGroup>
//                   </Form>    
//                                 </div>}
//               </div>
//             </div>
//                 </div>
//                 {/* </div> */}

//           </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default Recoverpw;
